export enum AnalyticsPages {
  CONTRACTS = 'contracts',
  CONTRACTS_DETAIL = 'contractsDetail',
}

export const AnalyticsPlaces = {
  LIST: 'contractsList',
  DETAIL: 'contractsDetail',
}
